var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "terminal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.269 27.269",
    style: {
      enableBackground: "new 0 0 27.269 27.269"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M25.323,1.948H1.949C0.871,1.948,0,2.816,0,3.894v19.481c0,1.074,0.871,1.946,1.949,1.946h23.374 c1.071,0,1.946-0.872,1.946-1.946V3.894C27.269,2.816,26.395,1.948,25.323,1.948z M9.315,3.411c0.536,0,0.971,0.431,0.971,0.973 c0,0.537-0.435,0.973-0.971,0.973c-0.538,0-0.978-0.436-0.978-0.973C8.337,3.842,8.777,3.411,9.315,3.411z M6.333,3.411 c0.535,0,0.973,0.431,0.973,0.973c0,0.537-0.438,0.973-0.973,0.973c-0.541,0-0.977-0.436-0.977-0.973 C5.356,3.842,5.792,3.411,6.333,3.411z M3.408,3.411c0.539,0,0.974,0.431,0.974,0.973c0,0.537-0.435,0.973-0.974,0.973 c-0.536,0-0.972-0.436-0.972-0.973C2.436,3.842,2.872,3.411,3.408,3.411z M25.323,23.376H1.949V6.839h23.374V23.376z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.949,
    y: 6.839,
    style: {
      fill: "#030104"
    },
    width: 23.374,
    height: 16.537
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.185,
    y: 9.496,
    style: {
      fill: "#030104"
    },
    width: 2.846,
    height: 2.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.233,
    y: 9.496,
    style: {
      fill: "#030104"
    },
    width: 2.847,
    height: 2.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.26,
    y: 9.496,
    style: {
      fill: "#030104"
    },
    width: 2.847,
    height: 2.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.185,
    y: 13.212,
    style: {
      fill: "#030104"
    },
    width: 2.846,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.233,
    y: 13.212,
    style: {
      fill: "#030104"
    },
    width: 2.847,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.26,
    y: 13.212,
    style: {
      fill: "#030104"
    },
    width: 2.847,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.195,
    y: 17.06,
    style: {
      fill: "#030104"
    },
    width: 2.848,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.246,
    y: 17.06,
    style: {
      fill: "#030104"
    },
    width: 2.845,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.271,
    y: 17.06,
    style: {
      fill: "#030104"
    },
    width: 2.847,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.206,
    y: 9.496,
    style: {
      fill: "#030104"
    },
    width: 2.843,
    height: 2.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.231,
    y: 9.496,
    style: {
      fill: "#030104"
    },
    width: 2.846,
    height: 2.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.206,
    y: 13.212,
    style: {
      fill: "#030104"
    },
    width: 2.843,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.231,
    y: 13.212,
    style: {
      fill: "#030104"
    },
    width: 2.846,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.215,
    y: 17.06,
    style: {
      fill: "#030104"
    },
    width: 2.846,
    height: 2.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.243,
    y: 17.06,
    style: {
      fill: "#030104"
    },
    width: 2.845,
    height: 2.849
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.f4fe0b71d47e1015ac767442e8cf2391.svg";
export { ForwardRef as ReactComponent };